import {Component, OnInit} from '@angular/core';
import pkg from '@root/package.json';

@Component({
  selector: 'neq-footer',
  templateUrl: './footer.component.html'
})
export class NeqFooterComponent implements OnInit {

  appVersion: string;
  year: number;

  ngOnInit() {
    this.appVersion = pkg['version'];
    this.year = new Date().getFullYear();
  }


}
